<template>
  <div class="select-parts-table">
    <div class="slide-tab">
      <button v-for="index in tableCount"
        :key="index"
        @click="selectPartsTable(index)"
        :class="{'active': selected(index) }"
      >
        {{ index }} {{ labelText }}
      </button>
      <div class="underline"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'layoutType',
    'tableCount',
    'currentTableId',
    'partsContainerType',
    'spacerPartsExists',
  ],
  computed: {
    labelText () {
      let labelText
      // パーツのレイアウトが縦ならrow、横ならcolumn
      if (this.layoutType === 'vertical') {
        labelText = '行目'
      } else if (this.layoutType === 'horizontal') {
        labelText = '列目'
      }
      return labelText
    },
    selected () {
      return function (index) {
        if (index === 1 || !this.spacerPartsExists) {
          // インデックス 1 = テーブルID 1
          // スペーサーパーツなし = インデックスとテーブルIDが同じ
          return index === this.currentTableId
        } else {
          // インデックス + インデックス - 1 = テーブルID
          // ２カラムならテーブルID 3、3カラムならテーブルID 5
          return index + (index - 1) === this.currentTableId
        }
      }
    }
  },
  methods: {
    selectPartsTable (partIndex) {
      // インデックス1 または スペーサーパーツなし：インデックスとテーブルIDが同じ
      // インデックス1以外：テーブルID = インデックス - (インデックス - 1)
      const index = (partIndex === 1 || !this.spacerPartsExists) ? partIndex : partIndex + (partIndex - 1)
      this.$emit('selectPartsTable', index)
    },
  },
  watch: {
    spacerPartsExists (value) {
      if (this.currentTableId !== 1) {
        if (this.spacerPartsExists) {
          // スペーサーなし → ありに変わった：選択テーブルを、今の選択テーブルID + (今の選択テーブルID - 1)に変更
          // テーブルID[3]を選択 → 3 + (3 - 1) = テーブルID[5]を選択
          const index = Number(this.currentTableId) + (Number(this.currentTableId) - 1)
          this.$emit('selectPartsTable', index)
        } else {
          // スペーサーあり → なしに変わった：選択テーブルを、今の選択テーブルID - (今の選択テーブルId / 2)に変更
          // テーブルID[5]を選択 → 5 - (5 / 2) = テーブルID[3]を選択
          const subNumber = Math.floor(Number(this.currentTableId) / 2)
          this.$emit('selectPartsTable', Number(this.currentTableId) - subNumber)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-tab {
  display: flex;
  padding: 0 16px;
  margin-bottom: 20px;
  button {
    color: rgba($commonFontColor, 0.3);
    background: #ffffff;
    border-radius: 2px;
    width: 100%;
    height: 35px;
    margin: 0 4px;
    line-height: 35px;
    font-size: 16px;
    &:focus {
      outline: 0;
    }
    &:hover {
      color: rgba($commonFontColor, 0.9);
      background: rgba($primaryHoverColor, 0.5);
    }
    &.active {
      color: #fff;
      background: $primaryActiveColor;
    }
  }
}
</style>
